<template>
  <div @click="handleClickOnLogo()" class="editor-header-logo-container">
    <span v-if="!isPresenterWhiteLabel">
      <aha-logo
        icon-only
        viewBox="0 0 1662 1602"
        width="27"
        height="26"
        class="hidden lg:block"
      />
      <aha-logo
        icon-only
        viewBox="0 0 1662 1602"
        width="22"
        height="21"
        class="lg:hidden"
      />
    </span>
    <!-- for white label -->
    <aha-icon
      v-else
      name="presentation"
      class="text-secondary-50"
      viewBox="0 0 24 24"
      width="20"
      height="20"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      isPresenterWhiteLabel: (state) => state.isPresenterWhiteLabel,
      isGuestUser: (state) => state.currentUser.isGuest,
    }),
  },
  methods: {
    handleClickOnLogo() {
      if (this.isGuestUser) {
        window.location.href = 'https://ahaslides.com/'
      } else if (this.$store.state.workingMode === 'team') {
        this.$router.push('/apps/team/workspace')
      } else this.$router.push('/apps/presentations')
    },
  },
}
</script>

<style lang="scss" scoped>
.editor-header-logo-container {
  @apply pl-3.5 pr-2 2xs:pr-5 flex items-center cursor-pointer h-full;
  padding-right: 0.5rem;
}
</style>
